import { Header } from './header'
import { Content } from './content'
import { Sidebar } from './sidebar'
import { LayoutProvider } from './layout.context'

interface LayoutProps {
  children: React.ReactNode
}

export const AppLayout = (props: LayoutProps) => {
  const { children } = props

  return (
    <LayoutProvider>
      <div>
        <Header />
        <div
          style={{
            display: 'flex',
            flex: 1,
            flexDirection: 'row',
            height: '100vh'
          }}
        >
          <Sidebar />
          <Content>{children}</Content>
        </div>
      </div>
    </LayoutProvider>
  )
}
